<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: null
    },
    text: {
      type: String,
      required: false,
      default: null
    },
    component: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      touchStart: null,
      touchMove: null,
      touchDelta: 0,
      isDragging: false
    }
  },
  computed: {
    textHtml() {
      return this.text.replace(/\n/g,'<br/>');
    },
    touchOffset() {
      if(!this.isDragging || !this.touchStart || !this.touchMove) {
        return null;
      }
      return Math.max(0,this.touchMove.y - this.touchStart.y);
    },
    contentStyle() {
      if(!this.isDragging || !this.touchOffset) {
        return {};
      }
      const percent = this.heightPercent(this.touchOffset);
      return {
        transform: 'translateY(' + Math.round(percent * 100
          ) + '%)',
        opacity: 1 - percent
      };
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    preventClick(e) {
      e.stopPropagation();
    },
    onTouchStart(e) {
      this.touchStart = { x : e.touches[0].pageX, y : e.touches[0].pageY };
    },
    onTouchMove(e) {
      if(this.touchStart) {
        const prevOffset = this.touchOffset;
        const newPos = { x : e.touches[0].pageX, y : e.touches[0].pageY };
        const newOffset = Math.max(0,newPos.y - this.touchStart.y);
        const delta = Math.sign(prevOffset - newOffset);

        if((this.isDragging && Math.abs(newOffset) > 0) || (delta === -1 && this.$refs.modalBody.scrollTop === 0)) {
          e.preventDefault();
          if(!this.isDragging) {
            this.isDragging = true;
            this.touchStart = newPos;
          }
          this.touchMove = newPos;
          this.touchDelta = delta;
        } else if((!this.isDragging && delta !== -1) || (this.isDragging && Math.abs(newOffset) <= 0)) {
          this.isDragging = false;
          this.touchStart = newPos;
          this.touchMove = newPos;
        }
      }
    },
    onTouchEnd(e) {
      this.isDragging = false;
      if(this.touchDelta === -1) {
        this.$nextTick(() => {
          this.$emit('close');
        });
      }
      this.touchStart = null;
      this.touchMove = null;
    },
    heightPercent(px) {
      if(px && this.$refs.modal) {
        return px / this.$refs.modal.offsetHeight;
      }
      return 0;
    }
  }
}
</script>
<template>
 <div :class="$style.overlay" @click="close">
    <dialog ref="modal" open :class="['modal--content',$style.modal, isDragging ? $style.modalDragging : null]" :style="contentStyle" @touchstart="onTouchStart"  @touchmove="onTouchMove" @touchend="onTouchEnd" @click="preventClick">
      <header :class="$style.header">
        <a href="#" :class="$style.closer" @click.prevent="close"><i :class="$style.closeIcon"></i></a>
      </header>
      <div ref="modalBody" :class="$style.body">
        <h2 v-if="title">{{title}}</h2>
        <p v-if="text" v-html="textHtml" />
        <component :is="component" v-if="component" />
        <slot />
      </div>
    </dialog>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: $layer-modal-z-index;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $color-body-bg-opacity;
}
.modal {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 720px;
  height: 100%;
  max-height: 100%;
  padding: 0;
  background: #fff;
  border: none;
  transition: all 0.3s ease-in-out;

  @media screen and (min-width: $size-breakpoint-sm) {
    max-height: 60vh;
    border-radius: 6px;
  }

  &, h1, h2, h3, h4, h5, h6 {
    color: $color-body-bg;
  }

  @extend %typography-medium;
  .modal__title {
    font-size: 32px;
  }
}
.modalDragging {
  transition: none;
}
.header {
  z-index: $layer-header-z-index;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  width: 100%;
  //height: 20px;
  padding: ($size-grid-size * 2) ($size-grid-size * 2) 0 ($size-grid-size * 2);
  box-shadow: 0 ($size-grid-size * 2) ($size-grid-size * 1) #fff;
}
.body {
  flex-grow: 1;
  padding: $size-grid-size * 2 $size-grid-size * 2;
  overflow: auto;

  @media screen and (min-width: $size-breakpoint-sm) {
    padding: $size-grid-size * 2 $size-grid-size * 6;
  }

  @media screen and (min-width: $size-breakpoint-lg) {
    padding: $size-grid-size * 6 $size-grid-size * 10;
  }
}
.closer {
  height: 20px;
  line-height: 20px;
}
.closeIcon {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;

  &::before,
  &::after {
    position: absolute;
    top: 50%;
    right: 0;
    left: 0;
    display: inline-block;
    height: 2px;
    content: '';
    background-color: $color-body-bg;
    border-radius: 2px;
    transition: all 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    transform: rotate(0deg);
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
}
</style>
